const versionTextMap = {
  Red: "red-blue",
  Blue: "red-blue",
  Yellow: "yellow",
  Gold: "gold-silver",
  Silver: "gold-silver",
  Crystal: "crystal",
  Ruby: "ruby-sapphire",
  Saphhire: "ruby-sapphire",
  Emerald: "emerald",
  "Fire Red": "firered-leafgreen",
  "Leaf Green": "firered-leafgreen",
  Diamond: "diamond-pearl",
  Pearl: "diamond-pearl",
  Platinum: "platinum",
  "Heart Gold": "heartgold-soulsilver",
  "Soul Silver": "heartgold-soulsilver",
  Black: "black-white",
  White: "black-white",
  "Black 2": "black-2-white-2",
  "White 2": "black-2-white-2",
  X: "x-y",
  Y: "x-y",
  "Omega Ruby": "omega-ruby-alpha-sapphire",
  "Alpha Sapphire": "omega-ruby-alpha-sapphire",
  Sun: "sun-moon",
  Moon: "sun-moon",
  "Ultra Sun": "ultra-sun-ultra-moon",
  "Ultra Moon": "ultra-sun-ultra-moon",
};

const baseButtonStyle = {
  maxWidth: "10rem",
  minWidth: "10rem",
  color: "white",
};

const red = {
  displayText: "Red",
  value: "red-blue",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#FF1111",
  },
};

const blue = {
  displayText: "Blue",
  value: "red-blue",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#1111FF",
  },
};

const yellow = {
  displayText: "Yellow",
  value: "yellow",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#FFD733",
  },
};

const gold = {
  displayText: "Gold",
  value: "gold-silver",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#DAA520",
  },
};

const silver = {
  displayText: "Silver",
  value: "gold-silver",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#C0C0C0",
  },
};

const crystal = {
  displayText: "Crystal",
  value: "crystal",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#4FD9FF",
  },
};

const ruby = {
  displayText: "Ruby",
  value: "ruby-sapphire",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#A00000",
  },
};

const sapphire = {
  displayText: "Sapphire",
  value: "ruby-sapphire",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#0000A0",
  },
};

const emerald = {
  displayText: "Emerald",
  value: "emerald",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#00A000",
  },
};

const fireRed = {
  displayText: "Fire Red",
  value: "firered-leafgreen",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#FF7327",
  },
};

const leafGreen = {
  displayText: "Leaf Green",
  value: "firered-leafgreen",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#00DD00",
  },
};

const diamond = {
  displayText: "Diamond",
  value: "diamond-pearl",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#AAAAFF",
  },
};

const pearl = {
  displayText: "Pearl",
  value: "diamond-pearl",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#FFAAAA",
  },
};

const platinum = {
  displayText: "Platinum",
  value: "platinum",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#999999",
  },
};

const heartGold = {
  displayText: "Heart Gold",
  value: "heartgold-soulsilver",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#B69E00",
  },
};

const soulSilver = {
  displayText: "Soul Silver",
  value: "heartgold-soulsilver",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#C0C0E1",
  },
};

const black = {
  displayText: "Black",
  value: "black-white",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#444444",
  },
};

const white = {
  displayText: "White",
  value: "black-white",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#E1E1E1",
  },
};

const black2 = {
  displayText: "Black 2",
  value: "black-2-white-2",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#424B50",
  },
};

const white2 = {
  displayText: "White 2",
  value: "black-2-white-2",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#E3CED0",
  },
};

const x = {
  displayText: "X",
  value: "x-y",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#025DA6",
  },
};

const y = {
  displayText: "Y",
  value: "x-y",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#EA1A3E",
  },
};

const omegaRuby = {
  displayText: "Omega Ruby",
  value: "omega-ruby-alpha-sapphire",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#AB2813",
  },
};

const alphaSapphire = {
  displayText: "Alpha Sapphire",
  value: "omega-ruby-alpha-sapphire",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#26649C",
  },
};

const sun = {
  displayText: "Sun",
  value: "sun-moon",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#F1912B",
  },
};

const moon = {
  displayText: "Moon",
  value: "sun-moon",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#5599CA",
  },
};

const ultraSun = {
  displayText: "Ultra Sun",
  value: "ultra-sun-ultra-moon",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#E95B2B",
  },
};

const ultraMoon = {
  displayText: "Ultra Moon",
  value: "ultra-sun-ultra-moon",
  variant: "outlined",
  styles: {
    ...baseButtonStyle,
    background: "#226DB5",
  },
};

const verionButtonData = [
  red,
  blue,
  yellow,
  gold,
  silver,
  crystal,
  ruby,
  sapphire,
  emerald,
  fireRed,
  leafGreen,
  diamond,
  pearl,
  platinum,
  heartGold,
  soulSilver,
  black,
  white,
  black2,
  white2,
  x,
  y,
  omegaRuby,
  alphaSapphire,
  sun,
  moon,
  ultraSun,
  ultraMoon,
];

export { verionButtonData, versionTextMap };
